import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Divider,
  Chip,
  Container,
  Avatar
} from '@mui/material';
import SchoolIcon from '@mui/icons-material/School';
import GroupsIcon from '@mui/icons-material/Groups';
import EventIcon from '@mui/icons-material/Event';

const StudentChapterComponent = ({
  collegeName,
  collegeImage,
  totalMembers,
  leadership,
  sectorDistribution,
  eventPhotos,
  additionalContent
}) => {
  return (
    <Container maxWidth="lg" sx={{ my: 4 }}>
      {/* College Header Section */}
      <Card elevation={3} sx={{ mb: 4 }}>
        <Box sx={{ position: 'relative' }}>
          <CardMedia
            component="img"
            height="300"
            image={collegeImage}
            alt={collegeName}
            sx={{ objectFit: 'cover' }}
          />
          <Box
            sx={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              background: 'linear-gradient(transparent, rgba(0,0,0,0.8))',
              p: 3,
            }}
          >
            <Typography variant="h4" color="white" gutterBottom>
              {collegeName}
            </Typography>
            <Chip
              icon={<GroupsIcon />}
              label={`${totalMembers} Members`}
              sx={{ color: 'white', bgcolor: 'rgba(255,255,255,0.2)' }}
            />
          </Box>
        </Box>
      </Card>

      {/* Leadership Section */}
      <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
        Chapter Leadership
      </Typography>
      <Grid container spacing={4} sx={{ mb: 6 }}>
        {leadership.map((leader) => (
          <Grid item xs={12} sm={6} key={leader.position}>
            <Card>
              <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Avatar
                  src={leader.image}
                  sx={{ width: 80, height: 80 }}
                />
                <Box>
                  <Typography variant="h6">{leader.name}</Typography>
                  <Typography color="textSecondary">{leader.position}</Typography>
                  <Typography variant="body2">{leader.department}</Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Sector Distribution */}
      <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
        Sector-wise Distribution
      </Typography>
      <Grid container spacing={3} sx={{ mb: 6 }}>
        {sectorDistribution.map((sector) => (
          <Grid item xs={12} sm={4} key={sector.name}>
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  {sector.name}
                </Typography>
                <Typography variant="h4" color="primary">
                  {sector.count}
                </Typography>
                <Typography color="textSecondary">Students</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Event Photos */}
      <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
        Chapter Events
      </Typography>
      <Grid container spacing={2} sx={{ mb: 6 }}>
        {eventPhotos.map((photo, index) => (
          <Grid item xs={12} sm={4} md={3} key={index}>
            <Card>
              <CardMedia
                component="img"
                height="200"
                image={photo.url}
                alt={photo.caption}
              />
              <CardContent>
                <Typography variant="body2">{photo.caption}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Additional Content Section */}
      {additionalContent && (
        <Box sx={{ mt: 4 }}>
          <Divider sx={{ mb: 4 }} />
          {additionalContent}
        </Box>
      )}
    </Container>
  );
};

export default StudentChapterComponent;